<template>
  <v-container id="user-profile" fluid tag="section">
    <v-tabs v-model="tab" background-color="transparent" icons-and-text>
      <v-tab href="#tab-1">
        <span class="iconTabs"></span>
        Identité de facturation
      </v-tab>

      <v-tab href="#tab-2">
        <span class="iconTabs"></span>
        Gestion des Tarifs
      </v-tab>

      <v-tab href="#tab-3" v-if="$can('manage', 'AdminUser')">
        <span class="iconTabs"></span>
        Commercial
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :value="'tab-1'" :transition="false" :reverse-transition="false">
<!--        <user-billing-identity />-->
        <IdentityList></IdentityList>
      </v-tab-item>
      <v-tab-item :value="'tab-2'" :transition="false" :reverse-transition="false">
         <user-tariff-management/>
      </v-tab-item>
      <v-tab-item :value="'tab-3'" :transition="false" :reverse-transition="false" class="pr-8" v-if="$can('manage', 'AdminUser')">
          <user-commercial />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>


<script>
  import UserBillingIdentity from './UserBillingIdentity.vue';
  import UserTariffManagement from './UserTariffManagement.vue';
  import UserCommercial from './UserCommercial.vue';
  import IdentityList from '@/components/IdentityList.vue';

  export default {
    name: "userprofile",
    components: {
      UserBillingIdentity,
      UserTariffManagement,
      UserCommercial,
      IdentityList
    },
    data() {
      return {
        tab: null,
      };
    },
    created() {
    },
    methods: {}
  };
</script>
